export const TIME_SHOW_CHECKOUT = 5000;
export const TIMEOUT_ZERO = 0;
